import { render, staticRenderFns } from "./RecordHello.vue?vue&type=template&id=45790e23&"
import script from "./RecordHello.vue?vue&type=script&lang=ts&"
export * from "./RecordHello.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports